import type { SubscriptionCancelStore } from './interfaces'

import { LearnWayReason } from '@brighterly/lib-core-types/subscription/enums'

export const getLearnWayReason = (state: SubscriptionCancelStore): SubscriptionCancelStore['learnWayReason'] => state.learnWayReason
export const learnWayReasons = {
  isLearnWayReason: (state: SubscriptionCancelStore): boolean => !!state.learnWayReason,
  getLearnWayReason: (state: SubscriptionCancelStore): SubscriptionCancelStore['learnWayReason'] => getLearnWayReason(state),
  isDecreasePace: (state: SubscriptionCancelStore): boolean => state.learnWayReason === LearnWayReason.DecreasePace,
  isChangeSchedule: (state: SubscriptionCancelStore): boolean => state.learnWayReason === LearnWayReason.ChangeSchedule,
}
